<template>
  <v-app id="keep">
    <!-- <v-navigation-drawer
      color="grey lighten-3"
      v-model="drawerRight"
      :width="400"
      app
      clipped
      right
    >
      <v-list>
        <p class="font-weight-light title">PESANAN</p>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Single-line item</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Two-line item</v-list-item-title>
            <v-list-item-subtitle>Secondary text</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title>Three-line item</v-list-item-title>
            <v-list-item-subtitle>
              Secondary line text Lorem ipsum dolor sit amet,
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              consectetur adipiscing elit.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
      clipped-right
      color="green darken-2 white--text"
    >
      <v-app-bar-nav-icon color="white" @click="drawer = !drawer" />
      <span class="title ml-3 mr-5">Semanggi&nbsp;<span class="font-weight-light">POS</span></span>
      <v-spacer />
      <v-icon color="white" @click.stop="drawerRight = !drawerRight">shopping_cart</v-icon>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      color="grey lighten-3"
    >

      <v-list dense>
        <v-list-item link>
          <v-list-item-icon>
            <v-icon>shopping_basket</v-icon>
          </v-list-item-icon>

          <v-list-item-title>Semua Produk</v-list-item-title>
        </v-list-item>

        <v-list-group
          prepend-icon="list_alt"
        >
          <template v-slot:activator>
            <v-list-item-title>Pemesanan</v-list-item-title>
          </template>

          <v-list-item
            v-for="(admin, i) in admins"
            :key="i"
            link
          >
            <v-list-item-title v-text="admin[0]"></v-list-item-title>
            <v-list-item-icon>
              <v-icon v-text="admin[1]"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
      </v-list>

    </v-navigation-drawer> -->

    <Loader />
    <v-content>
      <customNotification />
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Loader from "./components/Loader";
import customNotification from "./components/Notification";
import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/auth";
import firebaseConfig from "../firebase-config.json";

export default {
  props: {
    source: String,
  },
  components: {
    Loader,
    customNotification,
  },
  data: () => ({
    drawer: false,
    drawerRight: false,
    admins: [
      ["Management", "people_outline"],
      ["Settings", "settings"],
    ],
    cruds: [
      ["Create", "add"],
      ["Read", "insert_drive_file"],
      ["Update", "update"],
      ["Delete", "delete"],
    ],
  }),
  async created() {
    // if ("serviceWorker" in navigator) {
    //   navigator.serviceWorker
    //     .register("./firebase-messaging-sw.js")
    //     .then((registration) => {
    //       console.log("Registration successful, scope is:", registration.scope);
    //     });
    //   if (!firebase.apps.length) {
    //     console.log("Initialize firebase...");
    //     firebase.initializeApp(firebaseConfig);
    //     firebase
    //       .auth()
    //       .signInAnonymously()
    //       .then((result) => {
    //         // console.log(result);
    //       })
    //       .catch((error) => {
    //         let errorCode = error.code;
    //         let errorMessage = error.message;
    //         console.log(`Error code ${errorCode} => ${errorMessage}`);
    //       });
    //   }
    // }
  },
};
</script>

<style scoped>
#keep .v-navigation-drawer__border {
  display: none;
}
</style>
